import React from 'react';
import { formatCurrency } from '../utils/formatCurrency';
interface InvoiceTotalsProps {
  subtotal: number;
  gstTotal: number;
  totalDiscount: number;
  total: number;
  amountReceived: number;
  balanceDue: number;
}
export function InvoiceTotals({
  subtotal,
  gstTotal,
  totalDiscount,
  total,
  amountReceived,
  balanceDue
}: InvoiceTotalsProps) {
  return <div className="flex justify-end mb-3" data-id="element-627">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 min-w-[380px] shadow-sm" data-id="element-628">
        <div className="space-y-2" data-id="element-629">
          <div className="flex justify-between items-center" data-id="element-630">
            <span className="text-xs font-medium text-neutral-600" data-id="element-631">
              Subtotal Before GST:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-632">
              {formatCurrency(subtotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-633">
            <span className="text-xs font-medium text-neutral-600" data-id="element-634">
              GST 9%:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-635">
              {formatCurrency(gstTotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-636">
            <span className="text-xs font-medium text-neutral-600" data-id="element-637">
              Total Discount:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-638">
              -{formatCurrency(totalDiscount)}
            </span>
          </div>

          <div className="h-px bg-neutral-200" data-id="element-639" />

          <div className="flex justify-between items-center" data-id="element-640">
            <span className="text-xs font-semibold text-neutral-700" data-id="element-641">
              Total Includes GST:
            </span>
            <span className="text-sm font-semibold text-neutral-900 tabular-nums" data-id="element-642">
              {formatCurrency(total)}
            </span>
          </div>

          <div className="h-px bg-neutral-200" data-id="element-643" />

          <div className="flex justify-between items-center" data-id="element-644">
            <span className="text-xs font-medium text-neutral-600" data-id="element-645">
              Less Amount Received:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-646">
              {formatCurrency(amountReceived)}
            </span>
          </div>

          <div className="h-px bg-neutral-300" data-id="element-647" />

          <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-4 px-4 py-2 rounded" data-id="element-648">
            <span className="text-sm font-bold text-neutral-900" data-id="element-649">
              Balance Due:
            </span>
            <span className="text-base font-bold text-blue-700 tabular-nums" data-id="element-650">
              {formatCurrency(balanceDue)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}